module.exports = __webpack_public_path__ + "img/image00012-min.db3204e3.jpeg";